import React from 'react';
import D20Animation from './components/D20Animation';
import Header from './components/Header';
import AboutSection from './components/AboutSection';
import CVSection from './components/CVSection';
import ArticlesSection from './components/ArticlesSection';
import ContactSection from './components/ContactSection';

function App() {
  return (
    <div className="App">
      <D20Animation />
      <div style={{
        position: 'relative',
        zIndex: 1,
        color: '#fff',
        fontFamily: 'Share Tech Mono, monospace',
        minHeight: '100vh',
      }}>
        <Header />
        <main>
          <AboutSection />
          <CVSection />
          <ArticlesSection />
          <ContactSection />
        </main>
      </div>
    </div>
  );
}

export default App; 